/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useContext } from 'react';
import { axios } from '../services/ServiceUtils';
import LanguageContext from './LanguageContext';

const ContactUsContext = React.createContext();
const { Provider, Consumer } = ContactUsContext;

const ContactUsProvider = props => {
  const [contactUs, setContactUs] = useState({
    title: '',
    dfsModules: {},
    description: '',
    error: false,
    errorStatus: false,
  });

  const { language } = useContext(LanguageContext);

  const { children } = props;
  const contactUsError = status => {
    setContactUs({
      title: '',
      dfsModules: {},
      description: '',
      error: true,
      errorStatus: status,
    });
  };

  useEffect(() => {
    axios
      .get('api/contact-us', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => {
        if (!result.data.dfsModules) {
          contactUsError(200);
        } else {
          setContactUs({
            title: result.data.title,
            // dfsModules: { modules: setModuleOrder(result.data.dfsModules.modules)},
            dfsModules: result.data.dfsModules,
            description: result.data.description,
            error: false,
            errorStatus: false,
          });
        }
      })
      .catch(e => {
        contactUsError(e);
        // eslint-disable-next-line
        console.error('request error', e);
      });
  }, [language]);

  return <Provider value={contactUs}>{children}</Provider>;
};

export { ContactUsProvider, Consumer as ConsumerProvider };
export default ContactUsContext;
